import { Box } from '@mui/material';
import Editor from 'react-simple-wysiwyg';

interface ArticleRichTextEditorProps {
  value: string;
  onChange: (_: string) => void;
  disabled?: boolean;
}

const ArticleRichTextEditor = (props: ArticleRichTextEditorProps) => {
  return (
    <Box
      sx={{
        '& .rsw-editor': {
          backgroundColor: 'common.white',
          color: 'common.black',
          minHeight: 320,
        },
        '& .rsw-toolbar': {
          backgroundColor: 'grey.100',
        },
        '& .rsw-ce': {
          backgroundColor: 'common.white',
          color: 'common.black',
          minHeight: 260,
        },
      }}
    >
      <Editor
        value={props.value}
        disabled={props.disabled}
        placeholder="Write the article content..."
        onChange={(event) => props.onChange(event.target.value)}
        style={{
          minHeight: 260,
        }}
      />
    </Box>
  );
};

export default ArticleRichTextEditor;
